import { render, staticRenderFns } from "./ServiceManage.vue?vue&type=template&id=56f296b2&scoped=true&"
import script from "./ServiceManage.vue?vue&type=script&lang=js&"
export * from "./ServiceManage.vue?vue&type=script&lang=js&"
import style0 from "./ServiceManage.vue?vue&type=style&index=0&id=56f296b2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56f296b2",
  null
  
)

export default component.exports